const messages = {
  step3: {
    actionBtn: "Pieteikties",
  },
};

export default {
  messages,
};
